import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { Drug, CreateDrugDto, UpdateDrugDto } from '../types/drug.types';

export const drugsApi = {
  getAll: async (): Promise<Drug[]> => {
    const response = await apiClient.get<Drug[]>(API_ENDPOINTS.DRUGS);
    return response.data;
  },

  getById: async (id: number): Promise<Drug> => {
    const response = await apiClient.get<Drug>(API_ENDPOINTS.DRUG_BY_ID(id));
    return response.data;
  },

  create: async (data: CreateDrugDto): Promise<Drug> => {
    const response = await apiClient.post<Drug>(API_ENDPOINTS.DRUGS, data);
    return response.data;
  },

  update: async (id: number, data: UpdateDrugDto): Promise<Drug> => {
    const response = await apiClient.put<Drug>(API_ENDPOINTS.DRUG_BY_ID(id), data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.DRUG_BY_ID(id));
  },
};

